import { render, staticRenderFns } from "./SubstantialContactDetails.vue?vue&type=template&id=0715ef06&scoped=true"
import script from "./SubstantialContactDetails.vue?vue&type=script&lang=js"
export * from "./SubstantialContactDetails.vue?vue&type=script&lang=js"
import style0 from "./SubstantialContactDetails.vue?vue&type=style&index=0&id=0715ef06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715ef06",
  null
  
)

export default component.exports